import React, { useState, useEffect } from 'react';
import FormField from '../common/FormField';
import Button from '../common/Button';
import { 
  FirearmSpecificExerciseDTO, 
  ExerciseSpecificDTO, 
  GradingTypeCategoryDTO,
  GradingTypeDTO,
  GradingCategoryDTO
} from '../../services/apiClient';
import { useExerciseSpecificApi } from '../../hooks/useExerciseSpecificApi';

interface GradingTypeCategoryFormProps {
  onSubmit: (gradingTypecategory: GradingTypeCategoryDTO) => void;
  onCancel: () => void;
  initialValues?: GradingTypeCategoryDTO;
  availableGradingCategories: GradingCategoryDTO[]; 
}

const GradingTypeCategoryForm: React.FC<GradingTypeCategoryFormProps> = ({
  onSubmit,
  onCancel,
  initialValues,
  availableGradingCategories
}) => {
  const [formData, setFormData] = useState<GradingTypeCategoryDTO>(initialValues || {});
  const [exerciseSpecifics, setExerciseSpecifics] = useState<ExerciseSpecificDTO[]>([]);
  const [selectedExerciseSpecifics, setSelectedExerciseSpecifics] = useState<ExerciseSpecificDTO[]>(
    initialValues?.gradingExerciseSpecifics || []
  );

  const exerciseSpecificApi = useExerciseSpecificApi();

  useEffect(() => {
    const loadData = async () => {
      try {
        // Load exercise specifics
        const specificsResponse = await exerciseSpecificApi.search({
          page: 1,
          pageSize: 9999,
          sortBy: 'DisplayPosition',
          sortDescending: false,
        });
        setExerciseSpecifics(specificsResponse?.data?.results || []);
      } catch (error) {
        console.error('Error loading exercise data:', error);
      }
    };

    loadData();
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onSubmit({
      ...formData,
      gradingExerciseSpecifics: selectedExerciseSpecifics
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <FormField
        id="grading"
        label="Grading Category"
        type="dropdown"
        value={formData.gradingCategoryId || ''}
        onChange={(e) => setFormData({ ...formData, gradingCategoryId: e.target.value })}
        options={availableGradingCategories.map(type => ({
          value: type.id as string,
          label: type.title || '',
        }))}
        placeholder="Select Grading Category"
        disabled={!!initialValues} // Disable type selection when editing
      />

      <FormField
        id="exerciseSpecifics"
        label="Exercise Specifics"
        type="multiselect"
        value={selectedExerciseSpecifics.map(spec => spec.id as string)}
        onChange={(e) => {
          const selectedIds = Array.isArray(e.target.value) ? e.target.value : [e.target.value];
          const selected = exerciseSpecifics.filter(spec => selectedIds.includes(spec.id as string));
          setSelectedExerciseSpecifics(selected);
        }}
        options={exerciseSpecifics.map(spec => ({
          value: spec.id as string,
          label: spec.title || '',
        }))}
        placeholder="Select Exercise Specifics"
      />

      <div className="flex justify-end space-x-4 mt-4">
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">{initialValues ? 'Update' : 'Add'} Linking</Button>
      </div>
    </form>
  );
};

export default GradingTypeCategoryForm;